import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { getDetail } from "./thunks/get-detail";

const name = "detail";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDetail.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
        state.detail = null;
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        state.detail = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(getDetail.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
